<div class="milestone-card-container flex flex-align-center-center">
	<div
		*ngFor="let card of _datasource"
		class="milestone-card"
		[attr.data-test]="getHeader(card.key).replace(' ', '-').toLowerCase() + '-card'"
	>
		<div class="info-box flex">
			<div class="card-thumbnail flex flex-align-center-center" [ngClass]="getIconClass(card.key)">
				<app-icon
					[name]="getIcon(card.key)"
					[color]="'var(--color-text-default)'"
					[size]="'26'"
					[lineWidth]="'1px'"
				></app-icon>
			</div>
			<div class="card-text">
				<div class="card-label" [attr.data-test]="'card-header'">{{ getHeader(card.key) | titlecase }}</div>
				<div class="card-value" [attr.data-test]="'card-value'" [ngClass]="getCardValueColor(card.key)">
					{{ getFormattedText(card) }}
				</div>
			</div>
		</div>
	</div>
</div>
